import React from "react";

const SupportEmail = () => {
  return (
    <div className="support-email-container">
      <p>
        Need help? support@omegavoid.com
      </p>
    </div>
  );
};

export default SupportEmail;